// extracted by mini-css-extract-plugin
export default {"base":"TS4aX","status-2":"xfHNn","status-3":"IgAEO"};